// WriteAction — the closed enum of mutation actions that go through canWrite.
// Adding an action requires:
//   1. Append a new value here
//   2. Wire the rule in the owning module's perms.ts via registerPerms({ canWriteRules })
//   3. Document the rank in DOCS/architecture/visibility-resolver.md
//
// `admin.override` is the special case: only manager+; every use writes
// an audit-log row (handled inside the resolver, not by callers).
import { z } from 'zod';
export const WriteAction = z.enum([
    // Generic CRUD on any resource.
    'create',
    'update',
    'delete',
    // Article-specific (also reused for newsletters / surveys publish).
    'publish',
    'unpublish',
    'archive',
    // Moderation.
    'comment.moderate',
    'forum.moderate',
    // Workshop / education.
    'attendance.mark',
    'parent.message',
    // Identity / groups.
    'role.assign',
    'group.invite',
    'group.role-change',
    'member.ban',
    // Files.
    'share.create',
    'share.revoke',
    // Admin override — every use audit-logged.
    'admin.override',
]);
//# sourceMappingURL=actions.js.map